import { render, staticRenderFns } from "./TimesButtons.vue?vue&type=template&id=0792c1ac"
import script from "./TimesButtons.vue?vue&type=script&lang=js"
export * from "./TimesButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports